module.exports = __webpack_public_path__ + "static/media/unreal-house2.e8ab3241.svg";